module.exports = __webpack_public_path__ + "static/wpml-a71d36387e757b0000978a2c40d909d8.png";